import { INumberToNumber } from '../interfaces/core';
import { action, makeObservable, observable } from 'mobx';
import { IRound } from '../interfaces/round';
import { IHistoryItem } from '../interfaces/bet';

class GameStore {

  gameId: number = 8;
  partnerId: number = 0;
  mode: string = 'fun';
  language: string = 'en';
  applicationId: number = 8;

  gameInitialized: boolean = false;

  minBetAmount: number = 20;
  maxBetAmount: number = 100000;
  maxWinAmount: number = 0;
  defaultBetAmount: number = 50;
  quickBets: number[] = [];
  lobbyEnabled: boolean = false;

  reportDuration: number = 0;
  betCloseToReportDuration: number = 0;
  reportToRoundFinishDuration: number = 0;
  roundStartToBetCloseDuration: number = 0;
  roundFinishToRoundStartDuration: number = 0;

  statistics: INumberToNumber = {};
  hotNumbers: number[] = [];
  coldNumbers: number[] = [];
  lastRounds: IRound[] = [];
  historyItems: IHistoryItem[] = [];

  get maxNumberCountPerTicket(): number {
    return this.gameId === 8 ? 8 : 10;
  };

  constructor() {
    makeObservable(this, {
      gameInitialized: observable,
      statistics: observable,
      hotNumbers: observable,
      coldNumbers: observable,
      lastRounds: observable,
      historyItems: observable,
      quickBets: observable,
      minBetAmount: observable,
      maxBetAmount: observable,
      defaultBetAmount: observable,
      maxWinAmount: observable,
      lobbyEnabled: observable,
      setStatistics: action,
      setLastRounds: action,
      setGameInitialized: action,
      setHistoryItems: action,
      setQuickBets: action,
      setMinBetAmount: action,
      setMaxWinAmount: action,
      setMaxBetAmount: action,
      setDefaultBetAmount: action,
      setLobbyEnabled: action,
    })
  }

  setStatistics = (statistics: INumberToNumber) => {
    const data = Object.keys(statistics)
      .map(x => ({ key: +x, value: statistics[+x] }))
      .sort((a, b) => a.value - b.value)
      .map(x => x.key);
    this.hotNumbers = data.slice(-5);
    this.coldNumbers = data.slice(0, 5);
    this.statistics = statistics;
  }

  setQuickBets = (quickBets: number[]) => {
    this.quickBets = quickBets;
  }

  setMinBetAmount = (amount: number) => {
    this.minBetAmount = amount;
  }

  setMaxBetAmount = (amount: number) => {
    this.maxBetAmount = amount;
  }

  setDefaultBetAmount = (amount: number) => {
    this.defaultBetAmount = amount;
  }

  setMaxWinAmount = (amount: number) => {
    this.maxWinAmount = amount;
  }

  setLastRounds = (lastRounds: IRound[]) => {
    this.lastRounds = lastRounds;
  }

  setGameInitialized = (gameInitialized: boolean) => {
    this.gameInitialized = gameInitialized;
  }

  setHistoryItems = (historyItems: IHistoryItem[]) => {
    this.historyItems = historyItems;
  }

  setPropertiesFromQueryString = () => {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    this.mode = params.mode;
    this.gameId = +params.gameId;
    this.partnerId = +params.partnerId;
    this.language = params.languageCode;
  }

  setLobbyEnabled = (lobbyEnabled: boolean) => {
    this.lobbyEnabled = lobbyEnabled;
  }

}

export const gameStore = new GameStore();
